import React, { useState } from 'react';
import './interactive.css';

const NODES = [
  {
    id: 'lxc-caddy',
    name: 'LXC: Caddy SSL Proxy',
    type: 'LXC Container',
    ip: '10.0.20.10',
    vlan: 'VLAN 20 (DMZ)',
    desc: 'Afhandeling van Let\'s Encrypt SSL-certificaten en reverse proxy routing naar interne services.',
    status: 'Online'
  },
  {
    id: 'lxc-docker',
    name: 'LXC: Docker Engine Host',
    type: 'LXC Container',
    ip: '10.0.30.15',
    vlan: 'VLAN 30 (Services)',
    desc: 'Host voor multi-container Docker Compose microservices, API backends en databases.',
    status: 'Online'
  },
  {
    id: 'vm-storage',
    name: 'PVE: ZFS Storage Pool',
    type: 'Storage Pool',
    ip: '10.0.10.5',
    vlan: 'VLAN 10 (Management)',
    desc: 'Redundante mirrored storage pool voor betrouwbare persistent data opslag en snapshots.',
    status: 'Healthy'
  }
];

const HomelabTopology = () => {
  const [selectedNode, setSelectedNode] = useState(NODES[0]);

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-server" style={{ color: '#0284c7' }}></i> Proxmox VE Homelab Cluster & Topologie
        </div>
        <div style={{ fontSize: '0.78rem', color: 'var(--text-color)' }}>Self-Hosted Cluster</div>
      </div>

      <div className="interactive-content">
        <p style={{ fontSize: '0.84rem', color: 'var(--text-color)', margin: '0 0 1rem 0' }}>
          Selecteer een component in het homelab cluster om de netwerkligging en configuratie te inspecteren:
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '0.65rem', marginBottom: '1rem' }}>
          {NODES.map((node) => (
            <button
              key={node.id}
              type="button"
              className={`ansible-btn ${selectedNode.id === node.id ? '' : 'ansible-btn--secondary'}`}
              style={{ padding: '0.6rem 0.8rem', textAlign: 'left', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.2rem' }}
              onClick={() => setSelectedNode(node)}
            >
              <div style={{ fontWeight: 600, fontSize: '0.8rem' }}>{node.name}</div>
              <div style={{ fontSize: '0.68rem', opacity: 0.7 }}>{node.vlan}</div>
            </button>
          ))}
        </div>

        <div className="interactive-detail-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', borderBottom: '1px solid rgba(0,0,0,0.08)', paddingBottom: '0.5rem' }}>
            <span style={{ fontWeight: 700, color: '#0284c7' }}>{selectedNode.name}</span>
            <span style={{ color: '#10b981', fontWeight: 600 }}><i className="fas fa-circle" style={{ fontSize: '0.5rem', verticalAlign: 'middle', marginRight: '4px' }}></i>{selectedNode.status}</span>
          </div>
          <div style={{ marginBottom: '0.25rem' }}><strong>Type:</strong> {selectedNode.type}</div>
          <div style={{ marginBottom: '0.25rem' }}><strong>Netwerk Segment:</strong> {selectedNode.vlan} (IP: <code>{selectedNode.ip}</code>)</div>
          <div style={{ marginTop: '0.5rem', color: 'var(--text-color)' }}>{selectedNode.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default HomelabTopology;
